export default __webpack_public_path__ + "static/media/weightloss@3x.39d075e4.jpg";